import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function formatDate(dateString) {
  if (!dateString) return '';
  // Parse date-only strings (YYYY-MM-DD) as local date to avoid timezone shift
  if (dateString.match(/^\d{4}-\d{2}-\d{2}$/)) {
    const [year, month, day] = dateString.split('-').map(Number);
    const date = new Date(year, month - 1, day);
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    });
  }
  // For full ISO strings with time, use as-is
  const date = new Date(dateString);
  return date.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  });
}

export function formatDateTime(dateString) {
  if (!dateString) return '';
  const date = new Date(dateString);
  return date.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}

export function getGreeting() {
  const hour = new Date().getHours();
  if (hour < 12) return 'Good morning';
  if (hour < 17) return 'Good afternoon';
  return 'Good evening';
}

export function calculateOKRProgress(keyResults) {
  if (!keyResults || keyResults.length === 0) return 0;
  const total = keyResults.reduce((acc, kr) => {
    const progress = kr.target_value > 0 
      ? (kr.current_value / kr.target_value) * 100 
      : 0;
    return acc + Math.min(progress, 100);
  }, 0);
  return Math.round(total / keyResults.length);
}

// Alias for backward compatibility and clearer naming
export function calculateGoalProgress(actionItems) {
  return calculateOKRProgress(actionItems);
}

export function getPriorityColor(priority) {
  switch (priority) {
    case 'high':
      return 'bg-red-500';
    case 'medium':
      return 'bg-amber-500';
    case 'low':
      return 'bg-emerald-500';
    default:
      return 'bg-slate-400';
  }
}

export function getStatusBadge(status) {
  switch (status) {
    case 'completed':
    case 'done':
      return 'badge-success';
    case 'in_progress':
      return 'badge-warning';
    case 'active':
      return 'badge-primary';
    case 'todo':
      return 'badge-accent';
    default:
      return 'badge-primary';
  }
}

export function truncateText(text, maxLength = 100) {
  if (!text || text.length <= maxLength) return text;
  return text.slice(0, maxLength) + '...';
}

export function getCategoryIcon(category) {
  const icons = {
    foundations: 'BookOpen',
    'goal-setting': 'Target',
    execution: 'Zap',
    frameworks: 'Layout',
    leadership: 'Users',
    planning: 'Calendar',
    strategy: 'Compass',
    'problem-solving': 'Puzzle',
    optimization: 'TrendingUp',
    innovation: 'Lightbulb',
    reflection: 'Eye',
    visualization: 'Image',
  };
  return icons[category] || 'FileText';
}
